<div class="ui vertical menu">
  <a class="item" [routerLink]="['settings', 'account']" (click)="close()">Account Settings</a>
  <a class="item" [routerLink]="['settings', 'bgm']" (click)="close()">Bangumi Settings</a>
  <a class="item" [routerLink]="['settings', 'oauth2']" (click)="close()">OAuth2 Settings</a>
  <a class="item" [routerLink]="['settings', 'developer']" (click)="close()">Developer Settings</a>
  @if (showAdminURL) {
    <a class="item" [href]="adminUrl">Admin Console</a>
  }
  <a class="item" (click)="logout($event)">Logout</a>
</div>
